"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var inertia_react_1 = require("@inertiajs/inertia-react");
function JetValidationErrors(_a) {
    var className = _a.className;
    var props = (0, inertia_react_1.usePage)().props;
    var errors = props.errors;
    var hasErrors = Object.keys(errors).length > 0;
    if (!hasErrors) {
        return null;
    }
    return (react_1.default.createElement("div", { className: className, style: { backgroundColor: "#F7D0C9" } },
        react_1.default.createElement("ul", { className: "mt-3 list-disc list-inside text-sm", style: { listStyle: "none" } }, Object.keys(errors).map(function (key) { return (react_1.default.createElement("li", { key: key }, errors[key])); }))));
}
exports.default = JetValidationErrors;
